import { segmentTrackAction } from 'lib/segment'
import { EVENT } from 'lib/segment/const'
import StateStorage from 'lib/state-storage'
import ShopLanguageMap from 'lib/i18n/shop-language-map'
import { getISOCurrencyCodeWithShopID } from 'lib/utils/common/commonUtils'

const segmentQuickAddToBagClicked = ({
  id_product,
  product_name,
  size,
  id_site_category,
  ref_type,
  ref_id,
  price,
  currency,
}) => {
  // Read at call time: at import the shop/user can still be the defaults,
  // which would leave the event without a currency.
  const shop = StateStorage.getShop()
  const id_shop = ShopLanguageMap.getIdShopBySlug(shop)
  const id_customer = StateStorage.getAuthUser()?.id_customer
  const localCurrency = currency || getISOCurrencyCodeWithShopID(shop)
  const data = {
    id_shop,
    id_customer,
    id_product,
    product_name,
    size,
    quantity: 1,
    ...(localCurrency && { currency: localCurrency.toUpperCase() }),
    // `value` is the order value of the event (price x quantity); a
    // destination that maps AddToCart (e.g. Meta's Conversions API) reads
    // it rather than `price`.
    ...(price !== undefined && price !== null && { price, value: price }),
    id_site_category,
    ref_type,
    ref_id,
  }
  segmentTrackAction(EVENT.quickAddToCart, data)
}

export default segmentQuickAddToBagClicked
